import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';
import { NavbarModule } from '@/common/navbar/navbar.module';
import { DatePipe, NgClass, NgForOf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TourismEventsOrganizationComponent } from '../tourism-events-organization/tourism-events-organization.component';
import { Subject, takeUntil } from 'rxjs';
import { TourismEventsVehicleAddComponent } from '@/tourism-events/tourism-events-full/tourism-events-vehicle-add/tourism-events-vehicle-add.component';

@Component({
	selector: 'app-tourism-events-fleet',
	templateUrl: './tourism-events-fleet.component.html',
	styleUrls: ['./tourism-events-fleet.component.scss'],
	imports: [
		NavbarModule,
		NgSelectModule,
		FormsModule,
		ReactiveFormsModule,
		TourismEventsOrganizationComponent,
		NgClass,
		DatePipe,
		NgForOf,
		TourismEventsVehicleAddComponent,
	],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourismEventsFleetComponent extends TourismEventsComponent implements OnDestroy {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		category: '',
	};
	fault = '';
	faultError = false;
	private readonly destroy$ = new Subject<void>();

	protected defaultValues(): void {
		this._serviceEvent.getOrganization();
		this._serviceEvent.organization.pipe(takeUntil(this.destroy$)).subscribe((result) => {
			this.event.client = result;
			this.event.clientEvent = {
				client: result.id,
				event: null,
				isOrganization: '1',
			};
		});
		this.event.status = 'CONFIRMED';
		this.event.type = 'EVENT';
		this.event.category = CategoryEvent.FLEET;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	changeDateFrom(date: string): void {
		this.event.date_from = date;
		this.calculateDateTo();
		this.calculateDatePrepare();
		this.calculateDateDeadline();
	}
}
